// extracted by mini-css-extract-plugin
export var blue = "_17-g";
export var brand = "_17-c";
export var darkGrey = "_17-f";
export var disabled = "_17-6";
export var disabledSubtle = "_17-7";
export var error = "_17-8";
export var green = "_17-h";
export var grey = "_17-e";
export var icon = "_17-0";
export var inherit = "_17-b";
export var lightGrey = "_17-d";
export var orange = "_17-j";
export var pink = "_17-l";
export var primary = "_17-1";
export var purple = "_17-m";
export var quaternary = "_17-4";
export var quinary = "_17-5";
export var red = "_17-k";
export var secondary = "_17-2";
export var success = "_17-a";
export var tertiary = "_17-3";
export var warning = "_17-9";
export var white = "_17-n";
export var yellow = "_17-i";